<script setup>
import {useLocalePath} from 'vue-i18n-routing'
const {locale} = useI18n()
const localePath = useLocalePath()

const props = defineProps({
  type: {
    type: String,
    required: true,
  },
  classes: {
    type: String,
  },
  slug: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  images: {
    type: Array,
  },
})
</script>

<template>
  <div class="related-item sensible" :class="classes">
    <NuxtLink :to="localePath(`/${props.type}/${props.slug}`)">
      <SharedBasicImage
        v-if="props.images"
        :assets="props.images"
        :animate="false"
        class="related-image" />
      <div class="related-content">
        <span class="related-label">{{ props.label }}</span>
        <div class="related-title">
          {{ props.title }}
        </div>
        <div class="cta sensible cta--light">
          {{ $t('discover') }}
          <div class="menu-link-btn btn btn--round-small btn--round-light">
            <svg class="icon icon--btn-round-small">
              <use xlink:href="#icon-arrow"></use>
            </svg>
          </div>
        </div> 
      </div>
    </NuxtLink>
  </div>
</template>

<style lang="scss">
.related-item{
  aspect-ratio: 3 / 2;
  display: block;
  background-color: $color-blue;
  overflow: hidden;
  position: relative;

  @include mq(lg) {
    aspect-ratio: 1 / 1;
  }
  
  a{
    color: $color-white;
    cursor: none;
    text-decoration: none;
  }

  .related-content{
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: pxrem(20);
    z-index: 2;

    .cta{
      margin-top: auto;
    }

    .related-label{
      margin-bottom: pxrem(5);
    }

    .related-title{
      font-family: $font-secondary;
      font-size: $font-medium;
      font-weight: 400;
    }
  }

  .related-image{
    height: 100%;
    position: absolute !important;
    z-index: 0;

    &::after {
      background: linear-gradient(
        90deg,
        rgba($color-blue, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      );
      bottom: 0;
      content: '';
      display: block;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 1;
    }
  }

  &:not(:last-child){
    margin-bottom: pxrem(20);
  }
}
</style>
